import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg: #F0EDF8;
    --dot: #C9C3E8;
    --indigo: #5B52F0;
    --indigo-2: #4338CA;
    --navy: #15142A;
    --navy-2: #1A183C;
    --navy-3: #2D2A6E;
    --text: #15142A;
    --text-2: #3A3950;
    --text-3: #9896B0;
    --border: #E6E3F4;
    --gold: #FBBF24;
    --green: #10B981;
    --white: #ffffff;
  }

  .english-landing {
    font-family: 'DM Sans', 'Cairo', -apple-system, sans-serif;
    background: var(--bg);
    color: var(--text);
    direction: rtl;
    overflow-x: hidden;
    position: relative;
    min-height: 100vh;
  }

  .english-landing::before {
    content: '';
    position: fixed; inset: 0;
    background-image: radial-gradient(circle, var(--dot) 1px, transparent 1px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none; z-index: 0;
  }

  .english-landing a,
  .english-landing button {
    font-family: inherit;
  }

  .english-landing nav {
    position: sticky; top: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 52px; height: 68px;
    background: rgba(240,237,248,0.88);
    backdrop-filter: blur(18px);
    border-bottom: 1px solid var(--border);
  }
  .english-landing .nav-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; }
  .english-landing .logo-mark {
    width: 40px; height: 40px; border-radius: 11px;
    background: linear-gradient(135deg, var(--navy-2), var(--indigo-2));
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 800; color: #fff; letter-spacing: -0.5px;
    box-shadow: 0 4px 14px rgba(67,56,202,0.3);
  }
  .english-landing .logo-text { font-size: 15px; font-weight: 700; color: var(--navy); line-height: 1.2; }
  .english-landing .logo-sub  { font-size: 11px; color: var(--text-3); font-weight: 500; }
  .english-landing .nav-links { display: flex; align-items: center; gap: 2px; list-style: none; }
  .english-landing .nav-links a {
    font-size: 14px; color: var(--text-2); text-decoration: none;
    padding: 7px 15px; border-radius: 9px; transition: all 0.18s; font-weight: 500;
  }
  .english-landing .nav-links a:hover { color: var(--navy); background: rgba(91,82,240,0.07); }
  .english-landing .nav-ctas { display: flex; align-items: center; gap: 10px; }
  .english-landing .btn-ghost {
    padding: 9px 20px; border-radius: 10px; font-size: 14px; font-weight: 600;
    border: 1px solid var(--border); background: transparent; color: var(--text-2);
    cursor: pointer; transition: all 0.18s;
  }
  .english-landing .btn-ghost:hover { background: var(--white); border-color: #D0CCF0; color: var(--navy); }
  .english-landing .btn-primary {
    padding: 9px 22px; border-radius: 10px; font-size: 14px; font-weight: 700;
    border: none; background: var(--navy-2); color: #fff; cursor: pointer;
    transition: all 0.18s;
    box-shadow: 0 4px 14px rgba(26,24,60,0.22);
  }
  .english-landing .btn-primary:hover { background: var(--navy-3); transform: translateY(-1px); box-shadow: 0 8px 22px rgba(26,24,60,0.28); }

  .english-landing .hero {
    position: relative; z-index: 1;
    display: grid; grid-template-columns: 1fr 1.05fr;
    align-items: center; gap: 60px;
    padding: 80px 52px 90px;
    max-width: 1280px; margin: 0 auto;
  }

  .english-landing .hero-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    padding: 6px 14px; border-radius: 999px;
    background: var(--white); border: 1px solid var(--border);
    font-size: 12px; font-weight: 600; color: var(--text-3); margin-bottom: 22px;
    box-shadow: 0 1px 4px rgba(21,20,42,0.06);
  }
  .english-landing .eyebrow-badge {
    background: var(--navy-2); color: #fff; font-size: 10px; font-weight: 800;
    padding: 2px 8px; border-radius: 5px; letter-spacing: 0.5px;
  }

  .english-landing .hero h1 {
    font-size: 52px; font-weight: 900; line-height: 1.12; letter-spacing: -1.5px;
    color: var(--navy); margin-bottom: 20px; font-family: 'Cairo', sans-serif;
  }
  .english-landing .hero h1 em { font-style: normal; color: var(--indigo); }

  .english-landing .hero-desc {
    font-size: 17px; color: var(--text-2); line-height: 1.8;
    margin-bottom: 36px; max-width: 460px; font-family: 'Cairo', sans-serif;
  }

  .english-landing .hero-btns { display: flex; gap: 11px; align-items: center; margin-bottom: 38px; }
  .english-landing .btn-hp {
    padding: 14px 30px; border-radius: 12px; font-size: 15px; font-weight: 700;
    border: none; background: var(--navy-2); color: #fff; cursor: pointer;
    transition: all 0.18s;
    box-shadow: 0 8px 24px rgba(26,24,60,0.26);
  }
  .english-landing .btn-hp:hover { background: var(--navy-3); transform: translateY(-1px); }
  .english-landing .btn-hg {
    padding: 14px 28px; border-radius: 12px; font-size: 15px; font-weight: 600;
    border: 1px solid var(--border); background: var(--white); color: var(--text-2);
    cursor: pointer; transition: all 0.18s;
  }
  .english-landing .btn-hg:hover { border-color: #D0CCF0; color: var(--navy); }

  .english-landing .hero-pills { display: flex; flex-wrap: wrap; gap: 9px; margin-bottom: 42px; }
  .english-landing .pill {
    display: inline-flex; align-items: center; gap: 7px; padding: 7px 14px;
    border-radius: 999px; background: var(--white); border: 1px solid var(--border);
    font-size: 12px; font-weight: 600; color: var(--text-2);
    box-shadow: 0 1px 3px rgba(21,20,42,0.04);
  }
  .english-landing .pdot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

  .english-landing .hero-stats {
    display: grid; grid-template-columns: repeat(4,1fr);
    border-radius: 16px; overflow: hidden;
    border: 1px solid var(--border); background: var(--border); gap: 1px;
    box-shadow: 0 2px 8px rgba(21,20,42,0.06);
  }
  .english-landing .stat-cell { background: var(--white); padding: 18px 14px; text-align: center; }
  .english-landing .stat-num  { font-size: 24px; font-weight: 800; color: var(--navy); letter-spacing: -0.5px; }
  .english-landing .stat-lbl  { font-size: 11px; color: var(--text-3); margin-top: 3px; font-weight: 600; }

  .english-landing .dash-wrap { position: relative; }
  .english-landing .dash-wrap::before {
    content: '';
    position: absolute; inset: -50px;
    background: radial-gradient(ellipse 70% 70% at 50% 50%, rgba(91,82,240,0.12), transparent 70%);
    pointer-events: none;
  }

  .english-landing .float-tag {
    position: absolute; z-index: 2;
    display: flex; align-items: center; gap: 7px; padding: 8px 14px;
    border-radius: 11px; background: var(--white); border: 1px solid var(--border);
    font-size: 12px; font-weight: 600; color: var(--text-2);
    box-shadow: 0 8px 28px rgba(21,20,42,0.1);
  }
  .english-landing .ftop { top: -16px; right: 22px; }
  .english-landing .fbot { bottom: -14px; left: 22px; }

  .english-landing .dash-hero-card {
    position: relative; z-index: 1;
    background: linear-gradient(148deg, #1A183C 0%, #2D2A6E 55%, #4338CA 100%);
    border-radius: 22px; padding: 28px 26px; color: #fff;
    box-shadow: 0 24px 64px -16px rgba(26,24,60,0.5), inset 0 1px 0 rgba(255,255,255,0.08);
    overflow: hidden;
  }
  .english-landing .dg1 {
    position: absolute; top: -100px; right: -80px; width: 280px; height: 280px;
    border-radius: 50%; pointer-events: none;
    background: radial-gradient(circle, rgba(147,134,255,0.36) 0%, transparent 70%);
  }
  .english-landing .dg2 {
    position: absolute; bottom: -60px; left: -50px; width: 200px; height: 200px;
    border-radius: 50%; pointer-events: none;
    background: radial-gradient(circle, rgba(80,72,200,0.3) 0%, transparent 70%);
  }
  .english-landing .d-inner { position: relative; display: flex; flex-direction: column; gap: 0; }

  .english-landing .d-topbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
  .english-landing .exam-chip {
    display: inline-flex; align-items: center; gap: 6px; padding: 5px 12px;
    border-radius: 999px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.13);
    font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
  }
  .english-landing .chip-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--gold); display: inline-block; }
  .english-landing .d-window { font-size: 10px; color: rgba(255,255,255,0.45); letter-spacing: 0.5px; }
  .english-landing .d-title  { font-size: 26px; font-weight: 800; letter-spacing: -0.8px; line-height: 1.1; margin-bottom: 20px; }

  .english-landing .d-tabs { display: flex; gap: 7px; margin-bottom: 18px; direction: ltr; }
  .english-landing .d-tab {
    padding: 6px 16px; border-radius: 8px; font-size: 12px; font-weight: 600;
    color: rgba(255,255,255,0.5); background: transparent; border: 1px solid transparent;
    cursor: pointer; transition: all 0.16s;
  }
  .english-landing .d-tab.active { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.15); color: #fff; }

  .english-landing .s-rows { display: flex; flex-direction: column; gap: 13px; margin-bottom: 18px; }
  .english-landing .s-row  { display: flex; align-items: center; gap: 10px; direction: rtl; }
  .english-landing .s-ico  { font-size: 14px; flex-shrink: 0; }
  .english-landing .s-lbl  { font-size: 12px; color: rgba(255,255,255,0.7); font-weight: 600; min-width: 56px; text-align: right; }
  .english-landing .s-track{ flex: 1; height: 7px; background: rgba(255,255,255,0.1); border-radius: 4px; overflow: hidden; }
  .english-landing .s-fill { height: 100%; border-radius: 4px; }
  .english-landing .s-frac { font-size: 11px; color: rgba(255,255,255,0.4); min-width: 40px; text-align: left; font-variant-numeric: tabular-nums; }

  .english-landing .on-track {
    background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.09);
    border-radius: 13px; padding: 12px 14px;
    display: flex; align-items: center; gap: 11px; margin-bottom: 18px;
  }
  .english-landing .ot-ico   { width: 34px; height: 34px; border-radius: 50%; background: rgba(251,191,36,0.14); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .english-landing .ot-title { font-size: 13px; font-weight: 600; }
  .english-landing .ot-sub   { font-size: 11px; color: rgba(255,255,255,0.5); margin-top: 2px; line-height: 1.4; }

  .english-landing .d-total {
    background: var(--gold); border-radius: 12px; padding: 14px 18px;
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px;
  }
  .english-landing .dt-lbl { font-size: 12px; color: rgba(11,18,32,0.65); font-weight: 600; }
  .english-landing .dt-sub { font-size: 11px; color: rgba(11,18,32,0.55); margin-top: 1px; }
  .english-landing .dt-val { font-size: 28px; font-weight: 900; color: #0B1220; letter-spacing: -0.5px; }

  .english-landing .start-btn {
    width: 100%; padding: 14px; border-radius: 12px;
    background: #fff; color: #2D2A6E; border: none;
    font-size: 14px; font-weight: 700; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 8px;
    box-shadow: 0 10px 28px rgba(0,0,0,0.22); transition: all 0.15s ease;
  }
  .english-landing .start-btn:hover { transform: translateY(-1px); box-shadow: 0 14px 34px rgba(0,0,0,0.26); }

  .english-landing .page-sec {
    position: relative; z-index: 1;
    padding: 90px 52px;
    max-width: 1280px; margin: 0 auto;
  }
  .english-landing .sec-head { text-align: center; margin-bottom: 52px; }
  .english-landing .sec-head h2 { font-size: 38px; font-weight: 900; letter-spacing: -0.8px; color: var(--navy); font-family: 'Cairo', sans-serif; }
  .english-landing .sec-head p  { font-size: 16px; color: var(--text-3); margin-top: 10px; font-weight: 500; }

  .english-landing .feat-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 13px; margin-bottom: 13px; }
  .english-landing .feat-card {
    background: var(--white); border-radius: 20px; padding: 26px 24px;
    border: 1px solid var(--border); box-shadow: 0 1px 4px rgba(21,20,42,0.05);
    transition: all 0.2s ease; cursor: default;
  }
  .english-landing .feat-card:hover {
    transform: translateY(-3px); border-color: #D0CCF0;
    box-shadow: 0 12px 36px rgba(21,20,42,0.1);
  }
  .english-landing .feat-ico {
    width: 46px; height: 46px; border-radius: 13px;
    display: flex; align-items: center; justify-content: center;
    font-size: 20px; margin-bottom: 16px;
  }
  .english-landing .feat-card h3 { font-size: 16px; font-weight: 700; color: var(--navy); margin-bottom: 8px; }
  .english-landing .feat-card p  { font-size: 13px; color: var(--text-3); line-height: 1.7; font-weight: 500; }

  .english-landing .readiness-card {
    background: var(--white); border-radius: 20px; padding: 24px;
    border: 1px solid var(--border); box-shadow: 0 1px 4px rgba(21,20,42,0.05);
  }
  .english-landing .rc-header { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 20px; }
  .english-landing .rc-title { font-size: 14px; font-weight: 700; color: var(--navy); }
  .english-landing .rc-pct {
    font-size: 11px; color: #8280A8; font-weight: 600;
    background: #F1EFFE; padding: 3px 9px; border-radius: 6px;
  }
  .english-landing .bar-row  { margin-bottom: 13px; }
  .english-landing .bar-row:last-of-type { margin-bottom: 0; }
  .english-landing .bar-meta { display: flex; justify-content: space-between; margin-bottom: 5px; }
  .english-landing .bar-name { font-size: 12px; color: var(--text-2); font-weight: 600; }
  .english-landing .bar-val  { font-size: 11px; color: var(--text-3); font-variant-numeric: tabular-nums; }
  .english-landing .bar-track{ height: 7px; background: #EEEAF8; border-radius: 4px; overflow: hidden; }
  .english-landing .bar-fill { height: 100%; border-radius: 4px; }
  .english-landing .focus-btn {
    width: 100%; margin-top: 18px; padding: 10px 12px; border-radius: 10px;
    border: 1px solid var(--border); background: #FAFAFA;
    color: var(--text-2); font-size: 12px; font-weight: 600; cursor: pointer;
    transition: all 0.15s;
  }
  .english-landing .focus-btn:hover { border-color: #C4BEFF; background: #F3F0FD; color: var(--indigo); }

  .english-landing .compare-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 13px; }
  .english-landing .cmp-card {
    background: var(--white); border-radius: 20px; padding: 24px 26px;
    border: 1px solid var(--border); box-shadow: 0 1px 4px rgba(21,20,42,0.05);
  }
  .english-landing .cmp-card.ours { border-color: rgba(91,82,240,0.25); }
  .english-landing .cmp-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
  .english-landing .cmp-title  { font-size: 16px; font-weight: 700; color: var(--navy); }
  .english-landing .cmp-eye    { font-size: 11px; color: var(--text-3); font-weight: 600; margin-bottom: 3px; }
  .english-landing .ours-chip {
    display: inline-flex; align-items: center; gap: 5px;
    background: rgba(91,82,240,0.1); color: var(--indigo);
    font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 7px;
  }
  .english-landing .bad-chip {
    width: 30px; height: 30px; border-radius: 8px;
    background: rgba(239,68,68,0.07); color: rgba(239,68,68,0.7);
    display: flex; align-items: center; justify-content: center; font-size: 14px;
  }
  .english-landing .cmp-list { list-style: none; display: flex; flex-direction: column; }
  .english-landing .cmp-list li {
    display: flex; align-items: center; justify-content: space-between;
    font-size: 14px; color: var(--text-2); font-weight: 500;
    padding: 11px 0; border-bottom: 1px solid rgba(21,20,42,0.05);
  }
  .english-landing .cmp-list li:last-child { border-bottom: none; }
  .english-landing .chk { color: var(--green); font-size: 15px; font-weight: 700; }
  .english-landing .crs { color: rgba(239,68,68,0.7); font-size: 15px; }

  .english-landing footer {
    position: relative; z-index: 1;
    border-top: 1px solid var(--border); padding: 28px 52px;
    text-align: center; font-size: 13px; color: var(--text-3); font-weight: 500;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(22px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .english-landing .fu  { animation: fadeUp 0.55s ease both; }
  .english-landing .fu1 { animation-delay: 0.08s; }
  .english-landing .fu2 { animation-delay: 0.18s; }
  .english-landing .fu3 { animation-delay: 0.28s; }
  .english-landing .fu4 { animation-delay: 0.38s; }

  @keyframes pulse {
    0%,100% { box-shadow: 0 0 0 0 rgba(16,185,129,0.5); }
    50% { box-shadow: 0 0 0 4px rgba(16,185,129,0); }
  }
  .english-landing .live-dot { animation: pulse 2s infinite; }

  @media (max-width: 980px) {
    .english-landing nav,
    .english-landing .hero,
    .english-landing .page-sec,
    .english-landing footer {
      padding-left: 20px;
      padding-right: 20px;
    }

    .english-landing nav {
      gap: 12px;
      height: auto;
      padding-top: 14px;
      padding-bottom: 14px;
      flex-wrap: wrap;
    }

    .english-landing .nav-links {
      width: 100%;
      justify-content: center;
      flex-wrap: wrap;
    }

    .english-landing .hero {
      grid-template-columns: 1fr;
      gap: 32px;
      padding-top: 48px;
    }

    .english-landing .hero h1,
    .english-landing .sec-head h2 {
      font-size: 34px;
    }

    .english-landing .hero-btns,
    .english-landing .nav-ctas,
    .english-landing .feat-grid,
    .english-landing .compare-grid,
    .english-landing .hero-stats {
      grid-template-columns: 1fr;
      flex-wrap: wrap;
    }
  }
`;

const navItems = [
  ['المزايا', 'features'],
  ['الفوائد', 'benefits'],
  ['كيف يعمل', 'how'],
  ['الأسئلة', 'footer'],
];

const featureCards = [
  ['🧠', 'تقييم ذكي', 'ملاحظات مركزة بدل ملاحظات عامة ومزعجة.', 'rgba(155,127,244,0.12)'],
  ['📈', 'تقدم قابل للقياس', 'نتائجك محفوظة ويمكن مقارنتها مع الوقت.', 'rgba(61,217,235,0.1)'],
  ['🎯', 'خطة تحسين واضحة', 'تعرف بالضبط ماذا تفعل بعد كل محاولة.', 'rgba(251,191,36,0.12)'],
  ['🚀', 'جاهز للتوسع', 'إضافة الدفع والاشتراكات لاحقاً بسهولة.', 'rgba(108,142,255,0.1)'],
  ['📄', 'إدارة محتوى سهلة', 'رفع محتوى القراءة عن طريق JSON داخل لوحة الإدارة.', 'rgba(21,20,42,0.05)'],
  ['🧩', 'محتوى قريب من الواقع', 'أسئلة وتنسيق قريب من نمط اختبار القبول.', 'rgba(16,185,129,0.1)'],
];

const readiness = [
  ['الكتابة', '72%', '#5B52F0'],
  ['القراءة', '38%', '#83A7EA'],
  ['الاستماع', '31%', '#B4B0F5'],
];

export default function Landing() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState('Writing');

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="english-landing">
      <style>{styles}</style>

      <nav>
        <button className="nav-logo" type="button" onClick={() => scrollTo('top')} style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}>
          <div className="logo-mark">IE</div>
          <div>
            <div className="logo-text">Intake Exam</div>
            <div className="logo-sub">منصة التدريب الذكي</div>
          </div>
        </button>

        <ul className="nav-links">
          {navItems.map(([label, id]) => (
            <li key={id}>
              <a href={`#${id}`} onClick={(e) => { e.preventDefault(); scrollTo(id); }}>{label}</a>
            </li>
          ))}
        </ul>

        <div className="nav-ctas">
          <button className="btn-ghost" type="button" onClick={() => scrollTo('features')}>ابدأ الآن</button>
          <button className="btn-primary" type="button" onClick={() => navigate('/platform')}>الدخول للمنصة</button>
        </div>
      </nav>

      <div id="top" style={{ position: 'relative', zIndex: 1 }}>
        <div className="hero">
          <div>
            <div className="hero-eyebrow fu fu1">
              <span className="eyebrow-badge">B1</span>
              تدريب مركز لاختبار القبول
            </div>
            <h1 className="fu fu2">
              استعد لاختبار القبول
              <br />
              <em>بثقة ووضوح</em>
            </h1>
            <p className="hero-desc fu fu2">
              تجربة تدريب حديثة تساعدك تفهم مستواك سريعاً، وتركز على نقاط الضعف، وتصل لمستوى B1 بشكل علمي.
            </p>
            <div className="hero-btns fu fu3">
              <button className="btn-hp" type="button" onClick={() => navigate('/platform')}>ابدأ التدريب</button>
              <button className="btn-hg" type="button" onClick={() => scrollTo('how')}>شاهد كيف يعمل</button>
            </div>
            <div className="hero-pills fu fu3">
              <div className="pill"><span className="pdot" style={{ background: '#5B52F0' }} />خصوصية البيانات</div>
              <div className="pill"><span className="pdot" style={{ background: '#3DD9EB' }} />نتائج سريعة</div>
              <div className="pill"><span className="pdot" style={{ background: '#B4B0F5' }} />متوافق مع الجوال</div>
              <div className="pill"><span className="pdot" style={{ background: '#FBBF24' }} />لوحة متابعة واضحة</div>
            </div>
            <div className="hero-stats fu fu4">
              <div className="stat-cell"><div className="stat-num">24/7</div><div className="stat-lbl">متاح دائماً</div></div>
              <div className="stat-cell"><div className="stat-num">AI</div><div className="stat-lbl">تقييم ذكي</div></div>
              <div className="stat-cell"><div className="stat-num">B1</div><div className="stat-lbl">المستوى المطلوب</div></div>
              <div className="stat-cell"><div className="stat-num">3</div><div className="stat-lbl">مهارات كاملة</div></div>
            </div>
          </div>

          <div className="dash-wrap fu fu2">
            <div className="float-tag ftop">
              <span style={{ fontSize: '13px' }}>✦</span>
              تقييم فوري بالذكاء الاصطناعي
            </div>

            <div className="dash-hero-card">
              <div className="dg1" />
              <div className="dg2" />
              <div className="d-inner">
                <div className="d-topbar">
                  <div className="exam-chip"><span className="chip-dot" />نافذة الاختبار</div>
                  <div className="d-window">30 DEC 25 — 08 JAN 26</div>
                </div>
                <div className="d-title">لوحة<br />التحكم</div>

                <div className="d-tabs">
                  {['Reading', 'Speaking', 'Writing'].map((tab) => (
                    <button key={tab} className={`d-tab ${activeTab === tab ? 'active' : ''}`} type="button" onClick={() => setActiveTab(tab)}>
                      {tab}
                    </button>
                  ))}
                </div>

                <div className="s-rows">
                  <div className="s-row">
                    <span className="s-ico">✏️</span>
                    <span className="s-lbl">الكتابة</span>
                    <div className="s-track"><div className="s-fill" style={{ width: '82%', background: 'linear-gradient(90deg,#6C8EFF,#9B7FF4)' }} /></div>
                    <span className="s-frac">16.5/20</span>
                  </div>
                  <div className="s-row">
                    <span className="s-ico">🎙️</span>
                    <span className="s-lbl">المحادثة</span>
                    <div className="s-track"><div className="s-fill" style={{ width: '73%', background: 'linear-gradient(90deg,#3DD9EB,#6C8EFF)' }} /></div>
                    <span className="s-frac">11/15</span>
                  </div>
                  <div className="s-row">
                    <span className="s-ico">📖</span>
                    <span className="s-lbl">القراءة</span>
                    <div className="s-track"><div className="s-fill" style={{ width: '67%', background: 'linear-gradient(90deg,#B4B0F5,#3DD9EB)' }} /></div>
                    <span className="s-frac">22/33</span>
                  </div>
                </div>

                <div className="on-track">
                  <div className="ot-ico">
                    <svg width="15" height="15" viewBox="0 0 16 16" fill="#FBBF24"><path d="M8 1L10 6l5 .5-4 3.5 1 5-4-2.5L4 15l1-5-4-3.5L6 6z" /></svg>
                  </div>
                  <div>
                    <div className="ot-title">أنت على المسار الصحيح</div>
                    <div className="ot-sub">45 دقيقة يومياً تكفي للوصول للمستوى المطلوب</div>
                  </div>
                </div>

                <div className="d-total">
                  <div>
                    <div className="dt-lbl">المستوى الكلي</div>
                    <div className="dt-sub">جاهز للاختبار</div>
                  </div>
                  <div className="dt-val">B1+</div>
                </div>

                <button className="start-btn" type="button" onClick={() => navigate('/platform')}>
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="currentColor"><path d="M3 2l9 5-9 5z" /></svg>
                  ابدأ التدريب الآن
                </button>
              </div>
            </div>

            <div className="float-tag fbot">
              <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: 'var(--green)', display: 'inline-block' }} className="live-dot" />
              الممتحن الذكي جاهز
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: 'relative', zIndex: 1 }}>
        <div className="page-sec">
          <div id="benefits" className="sec-head">
            <h2>ركز على النتيجة، وليس كثرة الصفحات.</h2>
            <p>مصمم لتقليل التشتت: تدريب + تقييم + خطة تحسين.</p>
          </div>

          <div id="features" className="feat-grid">
            {featureCards.map(([icon, title, desc, bg]) => (
              <div className="feat-card" key={title}>
                <div className="feat-ico" style={{ background: bg }}>{icon}</div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>

          <div id="how" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '13px', marginTop: 0 }}>
            <div className="readiness-card">
              <div className="rc-header">
                <div className="rc-title">جاهزية الاختبار</div>
                <div className="rc-pct">47% جاهز</div>
              </div>
              {readiness.map(([name, value, color]) => (
                <div className="bar-row" key={name}>
                  <div className="bar-meta"><span className="bar-name">{name}</span><span className="bar-val">{value}</span></div>
                  <div className="bar-track"><div className="bar-fill" style={{ width: value, background: color }} /></div>
                </div>
              ))}
              <button className="focus-btn" type="button">ركز على القراءة ←</button>
            </div>

            <div className="compare-grid">
              <div className="cmp-card">
                <div className="cmp-header">
                  <div>
                    <div className="cmp-eye">بدون المنصة</div>
                    <div className="cmp-title">تدريب عشوائي</div>
                  </div>
                  <div className="bad-chip">✕</div>
                </div>
                <ul className="cmp-list">
                  <li>محتوى مبعثر ومكرر <span className="crs">✕</span></li>
                  <li>صعب تعرف أين تتحسن <span className="crs">✕</span></li>
                  <li>بدون قياس واضح للنتيجة <span className="crs">✕</span></li>
                </ul>
              </div>

              <div className="cmp-card ours">
                <div className="cmp-header">
                  <div>
                    <div className="cmp-eye" style={{ color: 'var(--indigo)' }}>مع المنصة</div>
                    <div className="cmp-title">منصتنا</div>
                  </div>
                  <div className="ours-chip">✓ الأفضل</div>
                </div>
                <ul className="cmp-list">
                  <li>تدريب قريب من نمط الاختبار <span className="chk">✓</span></li>
                  <li>تقييم واضح ومعايير <span className="chk">✓</span></li>
                  <li>متابعة تقدمك بسهولة <span className="chk">✓</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer id="footer">
        © 2025 Intake Exam — منصة التدريب الذكي لاختبارات القبول
      </footer>
    </div>
  );
}
